var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function AttentionSolid(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "m10.869 1.647 6.875 12.663v.021a2.122 2.122 0 0 1-.042 2.093 2.12 2.12 0 0 1-1.821 1.033H2.131a2.122 2.122 0 0 1-1.835-1.038 2.106 2.106 0 0 1-.028-2.109L7.149 1.647A2.128 2.128 0 0 1 9.01.542c.381 0 .754.103 1.082.297.326.195.595.474.777.808zM8.02 5.531a.994.994 0 1 1 1.99 0v4.57a.995.995 0 1 1-1.99 0v-4.57zm1.021 8.961a1.144 1.144 0 0 1-1.054-.704 1.143 1.143 0 0 1 .247-1.243 1.14 1.14 0 0 1 1.947.807 1.14 1.14 0 0 1-1.14 1.14z" }) })));
}
export default AttentionSolid;
